import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { callAPI, useStore, usePage, useUser } from "../../Utils/utils";
import Layout from "../../Components/Global/Layout";
import BreadCrumb from '../../Components/Global/BreadCrumb/BreadCrumb';
import Button from '../../Components/Global/Button';
import ProductTable from '../../Components/Product/ProductList/ProductTable'
import Pagination from "../../Components/Global/Pagination/Pagination";
import Loader from "../../Components/Global/Loader/Loader";
import { select_store_message, product_page_message } from "../../Constants/Messages"
import { product_page_labels } from "../../Constants/Labels"
import Alert from "../../Components/Alert/Alert";

const ProductPage = () => {

    const { store, setStore } = useStore()
    const { page, setPage } = usePage()
    const { user, setUser } = useUser();
    const [loading, setLoading] = useState(false)
    const [mode, setMode] = useState('active')
    const [alert, setAlert] = useState()
    const [searchValue, setSearchValue] = useState()
    const [searchResult, setSearchResult] = useState()
    const [payLoad, setPayLoad] = useState()
    const [currentPage, setCurrentPage] = useState(1)
    const [selectedProductType, setSelectedProductType] = useState('')
    const [selectedStore, setSelectedStore] = useState('')
    const [storesList, setStoresList] = useState([])
    const [resultInfo, setResultInfo] = useState({
        total_rows: "",
        fetched_rows: "",
        total_pages: "",
        page_size: 0,
        current_page: "",
        success: true,
        errors: ""
    })
    const navigate = useNavigate();
    // get store id from context and stor in store_id variable
    var store_id = store?.id

    const onPageSelect = (currentPage) => {
        setCurrentPage(currentPage)
        onClickSearchBtn(currentPage)
    }

    useEffect(() => {
        setPage({ isLoading: loading })
    }, [loading])

    useEffect(() => {
        var SavedMessage = localStorage.getItem('Message')
        if (SavedMessage != null) {
            setAlert({ text: SavedMessage, type: "error" })
        }
    }, [])

    // Fetch stores list for filter dropdown
    useEffect(() => {
        if (user?.auth_token) {
            callAPI('/admin/stores/list',
                {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'token': user?.auth_token
                    },
                    body: JSON.stringify(
                    {
                        "status": "active",
                        "current_page": 1
                    }
                )
                }, navigate, setLoading, setStore)
                .then(data => {
                    console.log("Stores API response:", data)
                    if (data.success && data.records) {
                        console.log("Stores returned:", data.records)
                        setStoresList(data.records)
                    }
                })
        }
    }, [user?.auth_token])

    // Debug store context and stores list
    console.log("Current store context:", store)
    console.log("Stores list loaded:", storesList)

    useEffect(() => {
        if (store_id) {
            var pay_load = {
                "store_id": store_id,
                "status": mode,
                "page_size": 10,
                "current_page": currentPage
            }

            // Include current filter values
            var conditions = []

            if (searchValue) {
                conditions.push({ field: "p.name", operator: "like", value: searchValue, dataType: "string" })
            }

            if (selectedProductType) {
                conditions.push({ field: "p.product_type", operator: "like", value: selectedProductType, dataType: "string" })
            }

            if (selectedStore) {
                conditions.push({ field: "s.store_name", operator: "like", value: selectedStore, dataType: "string" })
            }

            if (conditions.length > 0) {
                pay_load.filters = {
                    conditions: conditions
                }
            }
           
            setLoading(true)
            callAPI('/admin/products/by-store',
                {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'token': user?.auth_token
                    },
                    body: JSON.stringify(pay_load)
                }, navigate, setLoading, setStore)

                .then(data => {
                    if (data.success) {
                        setSearchResult(data.records)
                        setResultInfo({
                            total_rows: data.total_rows,
                            fetched_rows: data.fetched_rows,
                            total_pages: data.total_pages,
                            page_size: data.page_size,
                            current_page: data.current_page,
                            success: data.success,
                            errors: data.errors
                        })
                    } else {
                        setSearchResult([]) // Clear results on error
                    }
                }
                ).catch(error => {
                    setSearchResult([]) // Clear results on error
                })
        }
    }, [mode, store_id, currentPage, searchValue, selectedProductType, selectedStore])

    const onChangeSearchValue = (event) => {
        // console.log("on search value - ", event.target.value)
        setSearchValue(event.target.value)
        setSearchResult([]) // Clear previous results immediately
        buildAndSetPayload(1)
    }

    const onChangeProductType = (event) => {
        const newProductType = event.target.value
        setSelectedProductType(newProductType)
        setSearchResult([]) // Clear previous results immediately
        makeDirectAPICall(1, newProductType, selectedStore) // Pass new value directly
    }

    const onChangeStore = (event) => {
        const newStore = event.target.value
        setSelectedStore(newStore)
        setSearchResult([]) // Clear previous results immediately
        makeDirectAPICall(1, selectedProductType, newStore) // Pass new value directly
    }

    const buildAndSetPayload = (currentPage) => {
        var pay_load = {
            "store_id": store_id,
            "status": mode,
            "page_size": 10,
            "current_page": currentPage
        }

        var conditions = []

        if (searchValue) {
            conditions.push({ field: "p.name", operator: "like", value: searchValue, dataType: "string" })
        }

        if (selectedProductType) {
            conditions.push({ field: "p.product_type", operator: "like", value: selectedProductType, dataType: "string" })
        }

        if (selectedStore) {
            conditions.push({ field: "s.store_name", operator: "like", value: selectedStore, dataType: "string" })
        }

        if (conditions.length > 0) {
            pay_load.filters = {
                conditions: conditions
            }
        }

        setPayLoad(pay_load)
    }

    //during on search icon clicked get the result of store
    const onClickSearchBtn = (currentPage) => {
        getSearchResult(currentPage)
    }

    //on enter search the store list
    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            getSearchResult()
        }
    }

    const getSearchResult = (currentPage) => {
        buildAndSetPayload(currentPage)
    }

    // Direct API call function for immediate filter updates
    const makeDirectAPICall = (currentPage, productTypeOverride = null, storeOverride = null) => {
        if (!store_id) return
        
        // Use override values if provided, otherwise use current state
        const currentProductType = productTypeOverride !== null ? productTypeOverride : selectedProductType
        const currentStore = storeOverride !== null ? storeOverride : selectedStore
        
        var pay_load = {
            "store_id": store_id,
            "status": mode,
            "page_size": 10,
            "current_page": currentPage
        }

        var conditions = []

        if (searchValue) {
            conditions.push({ field: "p.name", operator: "like", value: searchValue, dataType: "string" })
        }

        
        if (currentProductType) {
            conditions.push({ field: "p.product_type", operator: "like", value: currentProductType, dataType: "string" })
        }

        if (currentStore) {
            conditions.push({ field: "s.store_name", operator: "like", value: currentStore, dataType: "string" })
        }


        if (conditions.length > 0) {
            pay_load.filters = {
                conditions: conditions
            }
        }

        setLoading(true)
        
        callAPI('/admin/products/by-store',
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'token': user?.auth_token
                },
                body: JSON.stringify(pay_load)
            }, navigate, setLoading, setStore)
            .then(data => {
                if (data.success) {
                    setSearchResult(data.records)
                    setResultInfo({
                        total_rows: data.total_rows,
                        fetched_rows: data.fetched_rows,
                        total_pages: data.total_pages,
                        page_size: data.page_size,
                        current_page: data.current_page,
                        success: data.success,
                        errors: data.errors
                    })
                } else {
                    setSearchResult([])
                }
            })
            .catch(error => {
                setSearchResult([])
            })
    }

    let select_store = store?.id == null || store?.id == undefined || store?.id == 0 || store?.name == "Global Admin" ? true : false

    const filter_store_list= storesList?.filter(a=>(a.store_name=="Gifting Good" || a.store_name=="GiftingGood" || a.is_separate_store==false));
console.log("filter_store_list",filter_store_list);

    return (
        <Layout>
            <div className="breadcrumb-wrapper breadcrumb-contacts">
                <div className="d-flex flex-column">
                    <BreadCrumb />
                </div>
                {select_store ? '' : <Button className={'btn btn-primary'} onClick={() => navigate('/admin/product/new')} value={product_page_labels?.product_add_page_labels?.title} />}
            </div>

            {alert?.text == product_page_message?.deleted_message ?
                <div className="text-center">
                    <Alert text={alert.text} type={alert.type} setAlert={setAlert} />
                </div>
                : ''}

            {select_store ?
                <div className="card card-default">
                    <div className="card-body  select_store">
                        <p className="text-center">{select_store_message?.select_store}</p>
                    </div>
                </div>
                :
                <div className=" cardWrapper card-default">
                    <div className="card-body">
                        <div className="table-responsive" >
                            <div className="dataTables_wrapper dt-bootstrap5 no-footer " >
                                <div className="filterTab mb-3">
                                    <div className="navAndSearchWrapper">
                                        <ul className="nav nav-tabs nav-style-border w-75" >
                                            <li className="nav-item" onClick={() => setMode('active')}>
                                                <span className={`nav-link ${mode == 'active' ? 'active' : ''}`} onClick={() => setMode('active')}>{product_page_labels?.product_page_tab_labels?.active}</span>
                                            </li>
                                            <li className="nav-item" onClick={() => setMode('inactive')}>
                                                <span className={`nav-link ${mode == 'inactive' ? 'active' : ''}`} onClick={() => setMode('inactive')}>{product_page_labels?.product_page_tab_labels?.inactive}</span>
                                            </li>
                                            <li className="nav-item" onClick={() => setMode('all')}>
                                                <span className={`nav-link ${mode == 'all' ? 'active' : ''}`} onClick={() => setMode('all')}>{product_page_labels?.product_page_tab_labels?.all}</span>
                                            </li>
                                        </ul>

                                        <div className="search-form">
                                            <div className="input-group ">
                                                <input type="text" className="form-control"
                                                    placeholder="Search by Product Name" onChange={onChangeSearchValue} onKeyDown={handleKeyDown} />
                                                <span className="search_icon" >
                                                    <i className="mdi mdi-magnify"></i>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    {/* Filter Dropdowns */}
                                    <div className="filter-dropdowns mt-3 d-flex gap-3">
                                        <div className="form-group">
                                            <label htmlFor="productTypeFilter" className="form-label">Product Type</label>
                                            <select 
                                                id="productTypeFilter"
                                                className="form-select shadow-none"
                                                value={selectedProductType}
                                                onChange={onChangeProductType}
                                            >
                                                <option value="">All Product Types</option>
                                                {Object.entries(product_page_labels?.[store.sub_domain =='glwd'?'glwd_product_type':'product_type']).map(([key, value]) => (
                                                    <option key={key} value={key}>{value}</option>
                                                ))}
                                            </select>
                                        </div>
                                        
                                       {store?.sub_domain==""&& <div className="ml-4 form-group">
                                            <label htmlFor="storeFilter" className="form-label">Store Name</label>
                                            <select 
                                                id="storeFilter"
                                                className="form-select shadow-none"
                                                value={selectedStore}
                                                onChange={onChangeStore}
                                            >
                                                <option value="">All Stores</option>
                                                {filter_store_list.map((store) => (
                                                    <option key={store.store_id} value={store.store_name}>{store.store_name}</option>
                                                ))}
                                            </select>
                                        </div>}
                                    </div>
                                </div>

                                {loading &&
                                    <Loader className={"table_loader"} />
                                }

                                {/* List Product Based On Store */}
                                <ProductTable mode={mode} searchResult={searchResult} loader={loading} />
                                <div className="paginationWrapper">
                                    <Pagination totalRows={resultInfo.total_rows} fetchedRows={resultInfo.fetched_rows} totalPages={resultInfo.total_pages} pageSize={resultInfo.page_size} currentPage={resultInfo.current_page} onPageSelect={onPageSelect} label='products' loader={loading} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            }
        </Layout>
    )
}
export default ProductPage;
